export default __webpack_public_path__ + "static/media/tiktok-circle.e6c95c7d.svg";